import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

// Pages
import { HomePage } from './screens';

const App = () => {
  return (
    <>
      <Suspense fallback={<span> Loading page</span>}>
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>

          <Route path="*">
            <p>Not found</p>
          </Route>
        </Switch>
      </Suspense>
    </>
  );
};

export default App;
